export default "__VITE_ASSET__DrQy1mRK__"